<template>
  <div>
    <h3 class="title_1a" v-if="form_data.step == 1" v-html="title"></h3>
    <ul :class="form_data.step > 1 ? 'activated' : ''">
      <li :class="form_data.selected_goal == 1 ? 'active' : ''">
        <div class="goal_box_wrap">
          <div class="goal_box">
            <div class="image">
              <i>Goal 1</i> <img alt="Vue logo" src="./../assets/goal_01.png" />
            </div>
            <div class="description">
              <p>
                Increase the productivity of my team while staying cost neutral
              </p>
              <button class="change_goal_btn" v-on:click="changeStep(1)" v-if="form_data.step > 1">
                Change Goal
              </button>
            </div>

            <button v-on:click="changeGoal(1)" v-if="form_data.step == 1">
              GET STARTED
            </button>
          </div>
        </div>
      </li>
      <li :class="form_data.selected_goal == 2 ? 'active' : ''">
        <div class="goal_box_wrap">
          <div class="goal_box">
            <div class="image">
              <i>Goal 2</i> <img alt="Vue logo" src="./../assets/goal_02.png" />
            </div>
            <div class="description">
              <p>
                Plan my CS budgets for expected growth
              </p>
              <button class="change_goal_btn" v-on:click="changeStep(1)" v-if="form_data.step > 1">
                Change Goal
              </button>
            </div>
            <button v-on:click="changeGoal(2)" v-if="form_data.step == 1">
              GET STARTED
            </button>
          </div>
        </div>
      </li>
      <li :class="form_data.selected_goal == 3 ? 'active' : ''">
        <div class="goal_box_wrap">
          <div class="goal_box">
            <div class="image">
              <i>Goal 3</i> <img alt="Vue logo" src="./../assets/goal_03.png" />
            </div>
            <div class="description">
              <p>
                Increase my CS function’s ROI
              </p>
              <button class="change_goal_btn" v-on:click="changeStep(1)" v-if="form_data.step > 1">
                Change Goal
              </button>
            </div>
            <button v-on:click="changeGoal(3)" v-if="form_data.step == 1">
              GET STARTED
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    form_data: {
      selected_goal: Number,
      step: Number
    },
    title: String,
    changeGoal: Function,
    changeStep: Function
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title_1a {
  font-family: "Roboto Slab", serif;
  color: #3e457b;
}
ul {
  display: flex;
  margin: 0 50px;
  padding: 0;
  font-family: "Roboto Slab", serif;
}
ul li {
  transition: width, height ease-in-out 9s;
  overflow: hidden;
  margin: 0;
  padding: 0;
  width: 33.33%;
}
ul li p {
  text-align: center;
  letter-spacing: 0px;
  color: #3e457b;
  opacity: 1;
  font-family: "Roboto Slab", serif;
  padding: 2em 0;
  font-weight: 500;
    min-height: 11em;
    display: flex;
    align-items:center;

    padding: 0;
    min-height: 10em;
    margin-bottom: 0px;
}
.activated {
  position: relative;
  overflow: hidden;
}
ul.activated li {
  width: 0;
  height: 0;
}
ul li img {
  min-height: 150px;
}
ul.activated li.active {
  width: 100%;
  height: auto;
}
ul li i {
  background: transparent linear-gradient(90deg, #3e457b 0%, #3e7bae 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 12px 15px 15px 0px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  font-style: normal;
  padding: 5px 10px;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: 500;
  font-family: "Roboto Slab", serif;
}

ul.activated .image {
  position: relative;
  display: inline-flex;
}
ul.activated li i {
  background: transparent linear-gradient(90deg, #3e457b 0%, #3e7bae 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 22px;
  opacity: 1;
  left: 0%;
  top: 0%;
  font-weight: 500;
  margin-left: -2%;
  margin-top: 30%;
  padding: 8px 25px;
  font-family: "Roboto Slab", serif;
}
ul li .goal_box_wrap {
  background: #fbf9f9 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 15px #0000001a;
  border-radius: 12px;
  opacity: 1;
  margin: 15px;
  position: relative;
  padding: 40px 10px;
  font-weight: 500;
}
ul li button {
  text-align: center;
  letter-spacing: 0px;
  color: #ef8e45;
  opacity: 1;
  border: 1px solid #ef8e45;
  border-radius: 6px;
  opacity: 1;
  padding: 10px 20px;
  font-size: 1em;
  font-weight: 500;
  font-family: "Roboto Slab", serif;
  cursor: pointer;
  background: none;
}
ul li.active button,
ul li button:hover {
  background: #ef8e45 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.2);
}
ul.activated {
  margin: 0px 0px -15px 0px;
}

ul.activated li .goal_box {
  display: flex;
  max-width: 800px;
  margin: 0 auto;
  justify-content: center;
  align-content: center;
}
ul.activated .goal_box_wrap {
  box-shadow: none;
  margin: 0;
  border-radius: 12px 12px 0 0;
}
ul.activated li .goal_box .image img {
  min-height: 250px;
}

ul.activated li .goal_box p {
  text-align: left;
  text-align: left;
  letter-spacing: 0px;
  color: #3e457b;
  opacity: 1;
  font-size: 1.8em;
  font-family: "Roboto Slab", serif;
    line-height: 1.5em;
}
ul.activated li .goal_box .description {
  text-align: left;
  padding-left: 100px;
  justify-content: center;
  align-content: center;
  display: flex;
  flex-direction: column;
  font-family: "Roboto Slab", serif;
}
ul.activated li .goal_box button {
  background: none;
  text-align: center;
  letter-spacing: 0px;
  color: #ef8e45;
  opacity: 1;
  border-radius: 0 none;
  border: 0 none;
  box-shadow: none;
  text-transform: uppercase;
  padding: 0;
  display: inline-flex;
}
ul.activated li .goal_box .description p{

    min-height: 7em;
    margin: 0;
}
@media all and (max-width: 800px) {
  ul {
    flex-direction: column;
  }

  ul li {
    width: 100%;
  }

ul li p {
    min-height: 0em;
}
}
.change_goal_btn{
  position: relative;
}
.change_goal_btn:after{
  content: ">";
    position: absolute;
    left: 6.3em;
    top: -0.25em;
    font-size: 1.2em;
    transform: scale(0.7,1.5);
    font-family: "Roboto Slab", serif;
    font-weight: 400;
}
@media all and (max-width: 700px) {
  ul.activated li .goal_box {
    flex-direction: column;
  }
  ul.activated li .goal_box .description {
    padding-top: 40px;
    padding-left: 0px;
  }
  ul.activated li i {
    margin-top: 12%;
  }
}
@media all and (max-width: 600px) {
  ul {
    margin: 0;
  }
}
</style>
